import axios from 'axios';

import { toast } from '@/shared/components/UI/Toast';
import { AUTH_KEYS, getAuthToken, removeAuthToken } from '@/shared/utils/authStorage';

const instance = axios.create({
    baseURL: import.meta.env.VITE_API_URL,
    timeout: 59000,
    headers: { 'Accept-Language': 'en', 'X-Tenant': localStorage.getItem('tenants_id') },
});

//WITHOUT REFRESH TOKEN FUNCTION
const instance2 = axios.create({
    baseURL: import.meta.env.VITE_API_URL,
    timeout: 59000,
    headers: {
        'Accept-Language': 'en',
    },
});

instance.interceptors.request.use(
    function (config) {
        // Do something before request is sent
        return config;
    },
    function (error) {
        // Do something with request error
        return Promise.reject(error);
    },
);

instance2.interceptors.request.use(
    function (config) {
        const accessToken = getAuthToken(AUTH_KEYS.ACCESS_TOKEN);
        if (accessToken) {
            config.headers['Authorization'] = `Bearer ${accessToken}`;
        }

        const tenant = localStorage.getItem('tenants_id');

        if (tenant) {
            config.headers['X-Tenant'] = localStorage.getItem('tenants_id');
        }
        return config;
    },
    function (error) {
        // Do something with request error
        return Promise.reject(error);
    },
);

instance.interceptors.response.use(
    (response) => {
        return response;
    },
    function (error) {
        // Handle 401 errors globally
        if (error.response && error.response.status === 401) {
            // Clear tokens and redirect to login
            toast.warning('Session expired. Please login again.');
            removeAuthToken(AUTH_KEYS.ACCESS_TOKEN);
            removeAuthToken(AUTH_KEYS.UUID);

            // Redirect to login after a short delay
            setTimeout(() => {
                window.location.href = '/login';
            }, 2000);
        }
        return error.response;
    },
);

instance2.interceptors.response.use(
    (response) => {
        return response;
    },
    function (error) {
        // Handle 401 errors globally
        if (error.response && error.response.status === 401) {
            // Clear tokens and redirect to login
            toast.warning('Session expired. Please login again.');
            removeAuthToken(AUTH_KEYS.ACCESS_TOKEN);
            removeAuthToken(AUTH_KEYS.UUID);

            // Redirect to login after a short delay
            setTimeout(() => {
                window.location.href = '/login';
            }, 2000);
        }
        return error.response;
    },
);

export { instance, instance2 };
